<section>
  <ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()">
          <ion-icon name="close-circle-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Importante</ion-title>
    </ion-toolbar>
  </ion-header>
  <hr>
</section>

<article>
  <ion-text>O MonitorAr necessita de acesso a sua localização <br/>
    para definir a estação principal automaticamente.<br/>
    Para que o modo automático seja habilitado, <br/>
    acesse as configurações do seu aparelho e permita que app MonitorAr acesse a sua localização.
    </ion-text>
</article>
